import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ConfigServices } from 'src/app/core/config';
import { ServicesService } from 'src/app/users/services.service';

@Injectable({
  providedIn: 'root'
})
export class BiometricService extends ServicesService {

  constructor(public http: HttpClient, public configService: ConfigServices,public cookieService: CookieService, private router: Router) {
    super('biometric', http, configService);
  }

  checkVerificationStatus(pin: string, idNumber: string) {
    const url = `${this.configService.getApi()}biometric/response/${pin}/${idNumber}`;
    return this.http.get(url,{responseType: 'text'});
  }

  startVerification(idNumber: string) {
    const url = `${this.configService.getApi()}biometric/start/${idNumber}`;
    return this.http.post(url, null, {withCredentials: true});
  }

  autoLoginWithBiometric(pin, idNumber: string) {
    const url = `${this.configService.getApi()}biometric/auto-login/${pin}/${idNumber}`;
    return this.http.post(url, null, {withCredentials: true, responseType: 'text'});
  }
}
